import React from 'react';
import classnames from 'classnames';

type Props = {
    value: any;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { value, onChange } = props;

    const onTextChange = (e) => {
        onChange(e.currentTarget.value);
    }

    return <div className="field  is-horizontal">
        <div className="field-label is-normal">
            <label className="label">Menge</label>
        </div>
        <div className="field-body">
            <div className="field">
                <div className="control">
                    <input className={classnames(["input", value.error ? "is-danger" : ""])} type="number" name="qty" value={value.value} onChange={onTextChange} />
                </div>
                {value.error && <p className="help is-danger">{value.error}</p>}
            </div>
        </div>
        
    </div>;
}